import { render, staticRenderFns } from "./xfsDownload.vue?vue&type=template&id=c7ec6e52"
import script from "./xfsDownload.vue?vue&type=script&lang=js"
export * from "./xfsDownload.vue?vue&type=script&lang=js"
import style0 from "./xfsDownload.vue?vue&type=style&index=0&id=c7ec6e52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports